// @flow
import { connect } from 'react-redux';
import {
  compose,
  withHandlers,
  lifecycle,
  branch,
  renderNothing,
} from 'recompose';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import PrivacyModal from '../privacy-modal/PrivacyModal';
import * as signals from '../../../application/signals';
import * as r from 'ramda';
import {
  shouldShowConsent,
  isRibbonDismissed,
  isExpanded,
} from '../../../domain/selectors';

const mapStateToProps = (state) => {
  return {
    expanded: isExpanded(state),
    cookies: [
      {
        name: 'analytics',
        optOut: true,
      },
      {
        name: 'marketing',
        optOut: true,
      },
      {
        name: 'support',
        optOut: true,
      },
      {
        name: 'essential',
        optOut: false,
      },
    ],
    initialValues: {
      expanded: false,
      analytics: false,
      marketing: false,
      support: false,
    },
    dismissed: isRibbonDismissed(state),
    show: shouldShowConsent(state),
  };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
  submitForm: signals.submitForm,
}, dispatch);

export const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    r.propEq('show', false),
    renderNothing,
    compose(
      withHandlers({
        onSubmit: ({ submitForm }) => (values) => new Promise((resolve, reject) => {
          submitForm(values, 'ribbon', 'privacyRibbon');
        }),
      }),
      reduxForm({
        form: 'privacyRibbon',
        propNamespace: 'form',
        destroyOnUnmount: false,
      }),
      lifecycle({
        componentDidMount: function() {
          this.props.form.change('__ready__', true);
        },
      }),
    ),
  ),
);

export default enhance(PrivacyModal);
